<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [patchForm]="configContracts"
  #formRef="ngForm"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="employeeContractConfig"
        >
          <span class="fs-3">{{
            'employeeModule.employeeContractConfig' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsed"
      class="card-body"
      [formGroup]="form"
      id="employeeContractConfig"
    >
      <div class="row">
        <div class="col-lg-6">
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.description' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="description"
                    value="{{ true }}"
                    (click)="patchValueForm('description', true)"
                    id="descriptionbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.description"
                  />
                  <label class="btn" for="descriptionbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="description"
                    id="descriptionbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('description', false);
                      patchValueForm('descriptionRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.description"
                  />
                  <label class="btn" for="descriptionbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.description.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="descriptionIsRequiredContract"
                    formControlName="descriptionRequired"
                  />
                  <label for="descriptionIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.description.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="descriptionIsRequiredContract2"
                    formControlName="descriptionRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="descriptionIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.externalContractNumber' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="externalContractNumber"
                    value="{{ true }}"
                    (click)="patchValueForm('externalContractNumber', true)"
                    id="externalContractNumberbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.externalContractNumber"
                  />
                  <label class="btn" for="externalContractNumberbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="externalContractNumber"
                    id="externalContractNumberbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('externalContractNumber', false);
                      patchValueForm('externalContractNumberRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.externalContractNumber"
                  />
                  <label class="btn" for="externalContractNumberbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.externalContractNumber.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="externalContractNumberIsRequiredContract"
                    formControlName="externalContractNumberRequired"
                  />
                  <label for="externalContractNumberIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.externalContractNumber.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="externalContractNumberIsRequiredContract2"
                    formControlName="externalContractNumberRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="externalContractNumberIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.startDate' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="startDate"
                    value="{{ true }}"
                    (click)="patchValueForm('startDate', true)"
                    id="startDatebtnradio1"
                    autocomplete="off"
                    [checked]="form.value.startDate"
                  />
                  <label class="btn" for="startDatebtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="startDate"
                    id="startDatebtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('startDate', false);
                      patchValueForm('startDateRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.startDate"
                  />
                  <label class="btn" for="startDatebtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.startDate.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="startDateIsRequiredContract"
                    formControlName="startDateRequired"
                  />
                  <label for="startDateIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.startDate.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="startDateIsRequiredContract"
                    formControlName="startDateRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="startDateIsRequiredContract"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.endDate' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="endDate"
                    value="{{ true }}"
                    (click)="patchValueForm('endDate', true)"
                    id="endDatebtnradio1"
                    autocomplete="off"
                    [checked]="form.value.endDate"
                  />
                  <label class="btn" for="endDatebtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="endDate"
                    id="endDatebtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('endDate', false);
                      patchValueForm('endDateRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.endDate"
                  />
                  <label class="btn" for="endDatebtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.endDate.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="endDateIsRequiredContract"
                    formControlName="endDateRequired"
                  />
                  <label for="endDateIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.endDate.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="endDateIsRequiredContract2"
                    formControlName="endDateRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="endDateIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.salary' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="salary"
                    value="{{ true }}"
                    (click)="patchValueForm('salary', true)"
                    id="salarybtnradio1"
                    autocomplete="off"
                    [checked]="form.value.salary"
                  />
                  <label class="btn" for="salarybtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="salary"
                    id="salarybtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('salary', false);
                      patchValueForm('salaryRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.salary"
                  />
                  <label class="btn" for="salarybtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>

                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.salary.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="salaryIsRequiredContract"
                    formControlName="salaryRequired"
                  />
                  <label for="salaryIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.salary.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="salaryIsRequiredContract2"
                    formControlName="salaryRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="salaryIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.vat' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="vat"
                    value="{{ true }}"
                    (click)="patchValueForm('vat', true)"
                    id="vatbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.vat"
                  />
                  <label class="btn" for="vatbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="vat"
                    id="vatbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('vat', false);
                      patchValueForm('vatRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.vat"
                  />
                  <label class="btn" for="vatbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.vat.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="vatIsRequiredContract"
                    formControlName="vatRequired"
                  />
                  <label for="vatIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.vat.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="vatIsRequiredContract2"
                    formControlName="vatRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="vatIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.contractHours' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="contractHours"
                    value="{{ true }}"
                    (click)="patchValueForm('contractHours', true)"
                    id="contractHoursbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.contractHours"
                  />
                  <label class="btn" for="contractHoursbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="contractHours"
                    id="contractHoursbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('contractHours', false);
                      patchValueForm('contractHoursRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.contractHours"
                  />
                  <label class="btn" for="contractHoursbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.contractHours.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="contractHoursIsRequiredContract"
                    formControlName="contractHoursRequired"
                  />
                  <label for="contractHoursIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>

                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.contractHours.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="contractHoursIsRequiredContract2"
                    formControlName="contractHoursRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="contractHoursIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.hoursPerWeek' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="hoursPerWeek"
                    value="{{ true }}"
                    (click)="patchValueForm('hoursPerWeek', true)"
                    id="hoursPerWeekbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.hoursPerWeek"
                  />
                  <label class="btn" for="hoursPerWeekbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="hoursPerWeek"
                    id="hoursPerWeekbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('hoursPerWeek', false);
                      patchValueForm('hoursPerWeekRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.hoursPerWeek"
                  />
                  <label class="btn" for="hoursPerWeekbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.hoursPerWeek.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="hoursPerWeekIsRequiredContract"
                    formControlName="hoursPerWeekRequired"
                  />
                  <label for="hoursPerWeekIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.hoursPerWeek.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="hoursPerWeekIsRequiredContract2"
                    formControlName="hoursPerWeekRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="hoursPerWeekIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.vacationHours' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="vacationHours"
                    value="{{ true }}"
                    (click)="patchValueForm('vacationHours', true)"
                    id="vacationHoursbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.vacationHours"
                  />
                  <label class="btn" for="vacationHoursbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="vacationHours"
                    id="vacationHoursbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('vacationHours', false);
                      patchValueForm('vacationHoursRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.vacationHours"
                  />
                  <label class="btn" for="vacationHoursbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.vacationHours.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="vacationHoursIsRequiredContract"
                    formControlName="vacationHoursRequired"
                  />
                  <label for="vacationHoursIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.vacationHours.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="vacationHoursIsRequiredContract2"
                    formControlName="vacationHoursRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="vacationHoursIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.nationalHolidayHours' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="nationalHolidayHours"
                    value="{{ true }}"
                    (click)="patchValueForm('nationalHolidayHours', true)"
                    id="nationalHolidayHoursbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.nationalHolidayHours"
                  />
                  <label class="btn" for="nationalHolidayHoursbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="nationalHolidayHours"
                    id="nationalHolidayHoursbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('nationalHolidayHours', false);
                      patchValueForm('nationalHolidayHoursRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.nationalHolidayHours"
                  />
                  <label class="btn" for="nationalHolidayHoursbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.nationalHolidayHours.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="nationalHolidayHoursIsRequiredContract"
                    formControlName="nationalHolidayHoursRequired"
                  />
                  <label for="nationalHolidayHoursIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.nationalHolidayHours.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="nationalHolidayHoursIsRequiredContract2"
                    formControlName="nationalHolidayHoursRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="nationalHolidayHoursIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.debtor' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="debtorPersonId"
                    value="{{ true }}"
                    (click)="patchValueForm('debtorPersonId', true)"
                    id="debtorPersonIdbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.debtorPersonId"
                  />
                  <label class="btn" for="debtorPersonIdbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="debtorPersonId"
                    id="debtorPersonIdbtnradio2"
                    value="{{ false }}"
                    (click)="
                      patchValueForm('debtorPersonId', false);
                      patchValueForm('debtorPersonIdRequired', false)
                    "
                    autocomplete="off"
                    [checked]="!form.value.debtorPersonId"
                  />
                  <label class="btn" for="debtorPersonIdbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="form.controls.debtorPersonId.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="debtorPersonIdIsRequiredContract"
                    formControlName="debtorPersonIdRequired"
                  />
                  <label for="debtorPersonIdIsRequiredContract">{{
                    'general.required' | translate
                  }}</label>
                </div>
                <div
                  class="form-check mt-3 ms-3"
                  *ngIf="!form.controls.debtorPersonId.value"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="debtorPersonIdIsRequiredContract2"
                    formControlName="debtorPersonIdRequired"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    for="debtorPersonIdIsRequiredContract2"
                    >{{ 'general.required' | translate }}</label
                  >
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="form-footer">
        <button class="btn btn-primary" type="submit">
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
